<!-- Navbar.vue -->
<template>
  <link
    rel="stylesheet"
    href="https://demos.creative-tim.com/notus-js/assets/vendor/@fortawesome/fontawesome-free/css/all.min.css"
  />
  <div class="fixed w-full z-30">
    <nav
      class="md:flex bg-white shadow w-full h-25 link-router-active border-t-2 border-b-2 border-orange-500"
    >
      <div class="container mx-auto w-full max-w-screen-xl">
        <div class="lg:flex lg:items-center lg:justify-between">
          <!-- Logo + botón móvil -->
          <div class="flex items-center justify-between">
            <img
              alt="IT logo"
              class="w-64 md:ml-40 ml-8 cursor-pointer"
              src="@/assets/LOGO.png"
              @click="$router.push('/')"
            />
            <div class="md:flex lg:hidden">
              <button
                @click="toggleMain()"
                type="button"
                class="text-gray-500 hover:text-gray-600 focus:outline-none focus:text-gray-600"
                aria-label="toggle menu"
              >
                <svg viewBox="0 0 24 24" class="w-6 h-6 mr-5 mt-5 fill-current">
                  <path
                    fill-rule="evenodd"
                    d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2z"
                  />
                </svg>
              </button>
            </div>
          </div>

          <!-- Menú -->
          <div class="lg:flex lg:mt-5" :class="showMain ? 'block' : 'hidden'">
            <ul
              class="bg-white md:px-2 ml-auto md:flex md:space-x-2 absolute md:relative top-full left-0 right-0"
            >
              <li>
                <router-link
                  to="/"
                  class="lg:p-4 py-3 px-0 block font-sans font-semibold border-b-2 border-transparent hover:border-otherblue hover:text-graynefro"
                >
                  Inicio
                </router-link>
              </li>

              <!-- Nuestra Clínica (nivel 1) -->
              <li class="relative parent">
                <div class="flex">
                  <div
                    @mouseenter="openNuestraClinica()"
                    @mouseleave="closeNuestraClinica()"
                    @click="toggleNuestraClinicaMobile"
                    class="bg-white md:flex m-auto space-x-2 lg:p-4 px-0 border-b-2 border-transparent hover:border-otherblue text-gray-500 hover:text-orange-500 md:w-full font-sans font-semibold cursor-pointer"
                    aria-haspopup="true"
                    :aria-expanded="showNuestraClinica"
                  >
                    Nuestra Clínica
                    <svg
                      class="h-5 w-5 flex text-gray-500 mt-1 transform transition"
                      :class="showNuestraClinica ? 'rotate-180' : ''"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      />
                    </svg>

                    <!-- Submenú Nuestra Clínica -->
                    <div
                      class="md:absolute bg-white md:w-56 md:mt-11 md:-ml-40 md:shadow-xl"
                      :class="showNuestraClinica ? 'block' : 'hidden'"
                    >
                      <router-link
                        to="/Acerca-De-Nosotros"
                        class="py-3 w-full block font-sans font-semibold border-b border-gray-200 hover:border-otherblue text-gray-500 hover:text-orange-500 text-sm text-center"
                      >
                        Acerca de Nosotros
                      </router-link>

                      <!-- Programa de Insignias (nivel 2, flyout) -->
                      <div
                        class="relative py-3 w-full block font-sans font-semibold border-b border-gray-200 hover:border-otherblue text-gray-500 hover:text-orange-500 text-sm text-center"
                        @mouseenter="openPI()"
                        @mouseleave="closePI()"
                        @click.stop="togglePIMobile"
                      >
                        Programa de Insignias
                        <div
                          class="md:absolute bg-white w-56 shadow-xl md:left-full md:top-0"
                          :class="showProgramaInsignia ? 'block' : 'hidden'"
                        >
                          <router-link
                            to="/Programa-Angel-Familia"
                            class="py-2 w-full block font-sans font-semibold border-b border-gray-200 hover:border-orange-500 text-gray-500 hover:text-orange-500 text-sm text-center"
                          >
                            Programa Ángel Familia
                          </router-link>
                          <router-link
                            to="/Programa-Plan-Canguro"
                            class="py-2 w-full block font-sans font-semibold border-b border-gray-200 hover:border-orange-500 text-gray-500 hover:text-orange-500 text-sm text-center"
                          >
                            Programa Plan Canguro
                          </router-link>
                        </div>
                      </div>

                      <router-link
                        to="/Noticias"
                        class="py-3 w-full block font-sans font-semibold border-b border-gray-200 hover:border-otherblue text-gray-500 hover:text-orange-500 text-sm text-center"
                      >
                        Noticias
                      </router-link>

                      <!-- Estados Financieros (nivel 2, flyout) -->
                      <div
                        class="relative py-3 w-full block font-sans font-semibold border-b border-gray-200 hover:border-otherblue text-gray-500 hover:text-orange-500 text-sm text-center"
                        @mouseenter="openEF()"
                        @mouseleave="closeEF()"
                        @click.stop="toggleEFMobile"
                      >
                        Estados Financieros
                        <div
                          class="md:absolute bg-white w-48 shadow-xl md:left-full md:top-0"
                          :class="showEstadosFinacieros ? 'block' : 'hidden'"
                        >
                          <a
                            v-for="year in [
                              2019, 2020, 2021, 2022, 2023, 2024, 2025,
                            ]"
                            :key="year"
                            href="https://clinicasagradafamilia.net/Estados-Financieros-1.pdf"
                            target="_blank"
                            class="py-2 w-full block font-sans font-semibold border-b border-gray-200 hover:border-otherblue text-gray-500 hover:text-orange-500 text-sm text-center"
                          >
                            {{ year }}
                          </a>
                        </div>
                      </div>

                      <router-link
                        to="/Copasst"
                        class="py-3 w-full block font-sans font-semibold border-b border-gray-200 hover:border-otherblue text-gray-500 hover:text-orange-500 text-sm text-center"
                      >
                        COPASST
                      </router-link>

                      <!-- ✅ Gestión de Riesgos (nuevo nivel 2, flyout) -->
                      <div
                        class="relative py-3 w-full block font-sans font-semibold border-b border-gray-200 hover:border-otherblue text-gray-500 hover:text-orange-500 text-sm text-center"
                        @mouseenter="openGR()"
                        @mouseleave="closeGR()"
                        @click.stop="toggleGRMobile"
                      >
                        Gestión de Riesgos
                        <div
                          class="md:absolute bg-white w-64 shadow-xl md:left-full md:top-0"
                          :class="showGestionRiesgos ? 'block' : 'hidden'"
                        >
                          <router-link
                            to="/SARLAFT-FPADM"
                            class="py-2 w-full block font-sans font-semibold border-b border-gray-200 hover:border-orange-500 text-gray-500 hover:text-orange-500 text-sm text-center"
                          >
                            SARLAFT/FPADM
                          </router-link>
                          <router-link
                            to="/Denuncias-Transparencia"
                            class="py-2 w-full block font-sans font-semibold border-b border-gray-200 hover:border-orange-500 text-gray-500 hover:text-orange-500 text-sm text-center"
                          >
                            Denuncias / Transparencia
                          </router-link>
                        </div>
                      </div>

                      <router-link
                        to="/Sistema-Unico-de-Habilitacion"
                        class="py-3 w-full block font-sans font-semibold border-b border-gray-200 hover:border-otherblue text-gray-500 hover:text-orange-500 text-sm text-center"
                      >
                        Sistema Único de Habilitación
                      </router-link>

                      <router-link
                        to="/Politica-de-Tratamiento-de-la-Informacion"
                        class="py-3 w-full block font-sans font-semibold border-b border-gray-200 hover:border-otherblue text-gray-500 hover:text-orange-500 text-sm text-center"
                      >
                        Política de Tratamiento de la Información
                      </router-link>
                    </div>
                  </div>
                </div>
              </li>

              <!-- SIAU -->
              <li class="relative parent">
                <div class="flex">
                  <div
                    @mouseenter="openSIAU()"
                    @mouseleave="closeSIAU()"
                    @click="toggleSIAUMobile"
                    class="bg-white m-auto md:inline-flex space-x-2 lg:p-4 px-0 border-b-2 border-transparent hover:border-otherblue text-gray-500 hover:text-orange-500 md:w-full font-sans font-semibold cursor-pointer"
                    aria-haspopup="true"
                    :aria-expanded="showSIAU"
                  >
                    SIAU
                    <svg
                      class="h-5 w-5 text-gray-500 mt-1 transform transition"
                      :class="showSIAU ? 'rotate-180' : ''"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      />
                    </svg>

                    <div
                      class="md:absolute bg-white md:w-56 md:mt-11 md:-ml-32 md:shadow-xl"
                      :class="showSIAU ? 'block' : 'hidden'"
                    >
                      <router-link
                        to="/Deberes-y-Derechos"
                        class="py-4 w-full block font-sans font-semibold border-b border-gray-200 hover:border-otherblue text-gray-500 hover:text-orange-500 text-sm text-center"
                      >
                        Deberes y Derechos
                      </router-link>
                      <router-link
                        to="/Pqr"
                        class="py-4 w-full block font-sans font-semibold border-b border-gray-200 hover:border-otherblue text-gray-500 hover:text-orange-500 text-sm text-center"
                      >
                        PQR
                      </router-link>
                      <router-link
                        to="/Citas-En-Linea"
                        class="py-4 w-full block font-sans font-semibold border-b border-gray-200 hover:border-otherblue text-gray-500 hover:text-orange-500 text-sm text-center"
                      >
                        Citas en Línea
                      </router-link>
                      <router-link
                        to="/Asociacion-De-Usuarios"
                        class="py-4 w-full block font-sans font-semibold border-b border-gray-200 hover:border-otherblue text-gray-500 hover:text-orange-500 text-sm text-center"
                      >
                        Asociación de Usuarios
                      </router-link>
                    </div>
                  </div>
                </div>
              </li>

              <li>
                <router-link
                  to="/Servicios"
                  class="lg:p-4 py-3 px-0 block font-sans font-semibold border-b-2 border-transparent hover:border-otherblue text-gray-500 hover:text-orange-500"
                >
                  <span>Servicios</span>
                </router-link>
              </li>
              <li>
                <router-link
                  to="/Contactenos"
                  class="lg:p-4 py-3 px-0 block font-sans font-semibold border-b-2 border-transparent hover:border-otherblue text-gray-500 hover:text-orange-500"
                >
                  <span>Contáctenos</span>
                </router-link>
              </li>
            </ul>
          </div>
          <!-- /Menú -->
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  name: "Navbar",
  setup() {
    // Estados globales
    const showMain = ref(false);

    // Nivel 1
    const showNuestraClinica = ref(false);
    const showSIAU = ref(false);

    // Nivel 2 (flyouts dentro de Nuestra Clínica)
    const showProgramaInsignia = ref(false);
    const showEstadosFinacieros = ref(false);
    const showGestionRiesgos = ref(false);

    /* --- helpers mobile: alternar --- */
    const toggleMain = () => (showMain.value = !showMain.value);
    const toggleNuestraClinicaMobile = () =>
      (showNuestraClinica.value = !showNuestraClinica.value);
    const toggleSIAUMobile = () => (showSIAU.value = !showSIAU.value);
    const togglePIMobile = () =>
      (showProgramaInsignia.value = !showProgramaInsignia.value);
    const toggleEFMobile = () =>
      (showEstadosFinacieros.value = !showEstadosFinacieros.value);
    const toggleGRMobile = () =>
      (showGestionRiesgos.value = !showGestionRiesgos.value);

    /* --- hover open/close (desktop) --- */
    const openNuestraClinica = () => (showNuestraClinica.value = true);
    const closeNuestraClinica = () => {
      showNuestraClinica.value = false;
      showProgramaInsignia.value = false;
      showEstadosFinacieros.value = false;
      showGestionRiesgos.value = false;
    };

    const openSIAU = () => (showSIAU.value = true);
    const closeSIAU = () => (showSIAU.value = false);

    const openPI = () => (showProgramaInsignia.value = true);
    const closePI = () => (showProgramaInsignia.value = false);

    const openEF = () => (showEstadosFinacieros.value = true);
    const closeEF = () => (showEstadosFinacieros.value = false);

    const openGR = () => (showGestionRiesgos.value = true);
    const closeGR = () => (showGestionRiesgos.value = false);

    return {
      // visibles
      showMain,
      showNuestraClinica,
      showSIAU,
      showProgramaInsignia,
      showEstadosFinacieros,
      showGestionRiesgos,
      // toggles
      toggleMain,
      toggleNuestraClinicaMobile,
      toggleSIAUMobile,
      togglePIMobile,
      toggleEFMobile,
      toggleGRMobile,
      // hover open/close
      openNuestraClinica,
      closeNuestraClinica,
      openSIAU,
      closeSIAU,
      openPI,
      closePI,
      openEF,
      closeEF,
      openGR,
      closeGR,
    };
  },
};
</script>

<style scoped>
/* Si notas “salto” del flyout, puedes agregar delay con CSS o usar group-hover */
</style>
